<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 mb-1">
                  Pedido #{{ pedido.id }} -
                  <span v-if="pedido.data_inicio && pedido.data_fim" class="badge badge-primary">Semanal</span>
                  <span v-else-if="
                    !pedido.data_inicio &&
                    !pedido.data_fim &&
                    !pedido.suplementar &&
                    !pedido.rapido
                  " class="badge badge-danger">SOS</span>
                  <span v-else-if="
                    !pedido.data_inicio &&
                    !pedido.data_fim &&
                    pedido.suplementar
                  " class="badge badge-secondary">Suplementar</span>
                  <span v-else-if="
                    !pedido.data_inicio && !pedido.data_fim && pedido.rapido
                  " class="badge badge-info">Rapido</span>
                </div>
                <div class="col-md-9 mb-1 text-right">
                  <router-link to="/pedidos" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <span class="badge" :class="'badge-' + pedido.status_class">
                    {{ pedido.status_f }}
                  </span>
                </div>
                <div class="col-md-6">
                  <label>Data inicial</label>
                  <input type="date" class="form-control" v-model="pedido.data_inicio" disabled />
                </div>
                <div class="col-md-6">
                  <label>Data final</label>
                  <input type="date" class="form-control" v-model="pedido.data_fim" disabled />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitante</label>
                  <v-select v-model="pedido.unidade_solicitante" class="vselect" :options="unidades"
                    :reduce="(unidades) => unidades.id" :label="'nome'" :disabled="![0, 11].includes(pedido.status)" />
                </div>
                <div class="col-md-6">
                  <label>Unidade solicitada</label>
                  <v-select v-model="pedido.unidade_solicitada" class="vselect" :options="unidades"
                    :reduce="(unidades) => unidades.id" :label="'nome'" :disabled="![0, 11].includes(pedido.status)" />
                </div>
                <div class="col-md-6 mt-1" v-if="pedido.status === 10">
                  <label>Ignorar validações </label>
                  <toggle-button v-model="ignorar_distribuicao" color="#15488A" :height="20" :width="40" />
                </div>

                <!-- Alerta para pedido parcial -->
                <div class="col-md-12 mt-2" v-if="temQuantidadeAtendida && pedido.status === 10">
                  <div class="alert alert-warning" role="alert">
                    <i class="fas fa-exclamation-triangle"></i>
                    <strong> Atenção!</strong> Pedido recebido parcialmente.
                  </div>
                </div>

                <div class="col-md-12">
                  <label>Observações</label>
                  <div class="row px-1">
                    <div class="col-md-12 p-1" style="border: 1px solid #ccc; border-radius: 8px"
                      v-if="![0, 11].includes(pedido.status)">
                      <div class="col-md-12 p-1" style="border: 1px solid #ccc; border-radius: 8px"
                        v-for="observacao in observacoes" :key="observacao.id">
                        <b>{{
                          (observacao.user_id
                            ? observacao.user.name
                            : "Não informado") +
                          " (" +
                          observacao.created_at_f +
                          ")"
                        }}</b>
                        <div v-html="observacao.texto"></div>
                      </div>
                    </div>
                    <div class="col-md-12 p-0" v-else>
                      <ckeditor :editor="editor" v-model="pedido.observacoes" :config="editorConfig"></ckeditor>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="col-md-9 mt-1" v-if="pedido.status === 0">
                  <label>Material</label>
                  <v-select class="vselect" :options="materiais" :label="'nome'" v-model="adicao.obj_material" />
                </div>
                <div class="col-md-2 mt-1" v-if="pedido.status === 0">
                  <label>Quantidade</label>
                  <input type="number" class="form-control" v-model="adicao.quantidade" />
                </div>
                <div class="col-md-1 mt-1" v-if="pedido.status === 0">
                  <label>Adicionar</label>
                  <button class="btn btn-primary" @click="add">
                    <i class="fa fa-plus" />
                  </button>
                </div>
                <div :class="pedido.status != 4 ? 'col-md-8 mt-1' : 'col-md-6 mt-1'
                  ">
                  <b>Material</b>
                </div>
                <div class="col-md-2 mt-1"><b>Solicitado</b></div>
                <div class="col-md-2 mt-1">
                  <b>{{ pedido.status === 0 ? "Atender" : "Atendido" }}</b>
                </div>
                <div :class="[4, 10].includes(pedido.status) ? 'col-md-2 mt-1' : 'd-none'
                  ">
                  <b>Recebido</b>
                </div>

                <div class="col-md-12 row p-0 m-0" id="lotes" v-for="(material_pedido, id) in pedido_material"
                  :key="id">
                  <hr />
                  <div :class="![4, 10].includes(pedido.status)
                    ? 'col-md-8 mt-1'
                    : 'col-md-6 mt-1'
                    ">
                    <span v-if="material_pedido.material">
                      {{ material_pedido.material.nome }}
                    </span>
                    <span v-else class="text-muted font-italic">
                      Material removido
                    </span>
                  </div>
                  <div class="col-md-2 mt-1" v-if="[0].includes(pedido.status)">
                    <input type="number" class="form-control" v-model="material_pedido.quantidade_solicitada" />
                  </div>
                  <div class="col-md-2 mt-1" v-else>
                    {{ material_pedido.quantidade_solicitada }}
                  </div>
                  <div class="col-md-2 mt-1" v-if="[0, 11].includes(pedido.status)">
                    <input type="number" class="form-control" v-model="material_pedido.quantidade_atendida" />
                  </div>
                  <div class="col-md-2 mt-1" v-else>
                    {{ material_pedido.quantidade_atendida }}
                  </div>
                  <div :class="pedido.status === 4 ? 'col-md-2 mt-1' : 'd-none'">
                    <span class="badge badge-secondary" v-if="material_pedido.atendido == null">Aguardando
                      recebimento</span>
                    <span class="badge badge-danger" v-if="material_pedido.atendido == 0">Não</span>
                    <span class="badge badge-success" v-if="material_pedido.atendido == 1">Sim</span>
                  </div>
                  <div class="col-md-12 mt-2" v-if="
                    material_pedido.estoques &&
                    material_pedido.estoques.length > 0 &&
                    pedido.status === 10
                  ">
                    <div class="d-flex justify-content-between align-items-center">
                      <strong>Lotes disponíveis:</strong>
                      <div class="text-right">
                        <small :class="{
                          'text-success': !material_pedido.erro_soma,
                          'text-danger':
                            material_pedido.tipo_erro_soma === 'excesso',
                          'text-warning':
                            material_pedido.tipo_erro_soma === 'insuficiente',
                          'text-muted': !material_pedido.quantidade_atendida,
                        }">
                          <i :class="{
                            fas: true,
                            'fa-check-circle':
                              !material_pedido.erro_soma &&
                              material_pedido.quantidade_atendida > 0,
                            'fa-times-circle':
                              material_pedido.tipo_erro_soma === 'excesso',
                            'fa-clock':
                              material_pedido.tipo_erro_soma ===
                              'insuficiente',
                          }" v-if="material_pedido.quantidade_atendida > 0"></i>
                          Soma a debitar:
                          {{ somaQuantidadesDebitar[material_pedido.id] || 0 }}
                          / {{ material_pedido.quantidade_atendida }}
                        </small>
                        <div v-if="material_pedido.erro_soma" :class="{
                          small: true,
                          'text-danger':
                            material_pedido.tipo_erro_soma === 'excesso',
                          'text-warning':
                            material_pedido.tipo_erro_soma === 'insuficiente',
                        }">
                          <i :class="{
                            fas: true,
                            'fa-exclamation-triangle':
                              material_pedido.tipo_erro_soma === 'excesso',
                            'fa-clock':
                              material_pedido.tipo_erro_soma ===
                              'insuficiente',
                          }"></i>
                          {{ material_pedido.mensagem_erro_soma }}
                        </div>
                      </div>
                    </div>
                    <ul class="list-unstyled mt-1">
                      <li v-for="estoque in material_pedido.estoques" :key="estoque.id" class="mb-2">
                        <div class="row">
                          <div class="col-md-8">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" :id="`lote-${estoque.id}`"
                                :value="estoque.id" v-model="estoque.selecionado" @change="onCheckboxChange(estoque)" />
                              <label class="form-check-label" :for="`lote-${estoque.id}`">
                                <span class="badge badge-info mr-2">{{
                                  estoque.lote
                                }}</span>
                                <span class="text"><strong>Qtd: {{ estoque.quantidade }}</strong></span>
                                <span class="text ml-2"><strong>Validade: {{ estoque.validade_f }}</strong></span>
                              </label>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <input type="number" placeholder="Quantidade para Debitar" :class="{
                              'form-control': true,
                              'is-invalid': estoque.erro_quantidade,
                            }" v-model="estoque.quantidade_debitar" :max="estoque.quantidade" min="0" step="0.01"
                              :disabled="!estoque.selecionado" />
                            <div v-if="estoque.erro_quantidade" class="invalid-feedback">
                              {{ estoque.mensagem_erro }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-12 row mt-2" v-if="pedido.status === 0">
                  <div class="col-md-6">
                    <button class="btn btn-outline-danger w-100" @click="reject">
                      Rejeitar
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button class="btn btn-outline-primary w-100" @click="authorize">
                      Autorizar
                      <i class="fas fa-thumbs-up"></i>
                    </button>
                  </div>
                </div>
                <div class="col-md-12 row mt-2" v-if="pedido.status === 11">
                  <hr />
                  <div class="col-md-6">
                    <button class="btn btn-outline-danger w-100" @click="reject">
                      Rejeitar
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button class="btn btn-outline-success w-100" data-toggle="modal" data-target="#approveModal">
                      Aprovar
                      <i class="fa fa-check"></i>
                    </button>
                    <div class="modal fade" id="approveModal" tabindex="-1" role="dialog"
                      aria-labelledby="approveModalTitle" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content w-100">
                          <div class="modal-header bg-primary">
                            <h5 class="modal-title" id="approveModalTitle" style="color: #ffffff !important">
                              Aprovar pedido
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body row">
                            <div class="col-md-12">
                              <h5>
                                Os seguintes materiais estão sendo alocados
                                nesse pedido:
                              </h5>
                              <hr />
                            </div>
                            <div class="col-md-6 mt-1"><b>Material</b></div>
                            <div class="col-md-3 mt-1"><b>Solicitado</b></div>
                            <div class="col-md-3 mt-1"><b>Atender</b></div>
                            <div class="col-md-12 row px-0 py-1 m-0" id="lotes" style="border-top: 1px solid #ccc"
                              v-for="(material_pedido, id) in pedido_material" :key="id">
                              <hr />
                              <div class="col-md-6">
                                <span v-if="material_pedido.material">
                                  {{ material_pedido.material.nome }}
                                </span>
                                <span v-else class="text-muted font-italic">
                                  Material removido do sistema
                                </span>
                              </div>

                              <div class="col-md-3">
                                {{ material_pedido.quantidade_solicitada }}
                              </div>
                              <div class="col-md-3">
                                {{ material_pedido.quantidade_atendida }}
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="approve" data-dismiss="modal"
                              aria-label="Close">
                              Aprovar <i class="fa fa-save"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 mt-2" v-if="[1, 6, 10].includes(pedido.status)">
                  <button :class="{
                    btn: true,
                    'btn-outline-success': podeFinalizarPedido,
                    'btn-outline-secondary': !podeFinalizarPedido,
                    'btn-block': true,
                  }" @click="finalizar()" :disabled="!podeFinalizarPedido" :title="!podeFinalizarPedido
                    ? 'A quantidade total para debitar deve ser igual à quantidade atendida para todos os materiais'
                    : ''
                    ">
                    <span v-if="podeFinalizarPedido">Finalizar pedido</span>
                    <span v-else>Finalizar pedido (aguardando distribuição completa)</span>
                  </button>
                </div>
                <div class="col-md-12 mt-2" v-if="[4, 7].includes(pedido.status)">
                  <button class="btn btn-outline-purple btn-block" @click="baixa()">
                    Solicitar baixa de estoque
                  </button>
                </div>
                <div class="col-12 mt-2" v-if="pedido.status === 1 || pedido.status === 6">
                  <button type="button" class="btn btn-primary btn-block" @click="reabrir()">
                    Reabrir
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "imageUpload",
  data() {
    return {
      ignorar_distribuicao: false,
      temQuantidadeAtendida: false,
      observacoes: {},
      pedido_material: [],
      pedido: {
        id: null,
        observacoes: '',
      },
      unidades: [],
      materiais: [],
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedlist",
          "bulletedlist",
          "|",
          "outdent",
          "indent",
          "|",
          "blockquote",
          "inserttable",
          "undo",
          "redo",
        ],
      },
      adicao: {
        id: "",
        material: "",
        obj_material: {},
        quantidade: "",
      },
    };
  },
  computed: {
    // Calcula a soma das quantidades a debitar por material
    somaQuantidadesDebitar() {
      const somasporMaterial = {};

      this.pedido_material.forEach((material_pedido) => {
        let soma = 0;
        if (material_pedido.estoques) {
          material_pedido.estoques.forEach((estoque) => {
            if (
              estoque.quantidade_debitar &&
              !isNaN(parseFloat(estoque.quantidade_debitar))
            ) {
              soma += parseFloat(estoque.quantidade_debitar);
            }
          });
        }
        somasporMaterial[material_pedido.id] = soma;
      });

      return somasporMaterial;
    },

    // Verifica se é possível finalizar o pedido (todas as quantidades devem estar corretas)
    podeFinalizarPedido() {
      if (this.ignorar_distribuicao) {
        return true;
      }
      // Verifica se todos os materiais têm quantidade para debitar igual à quantidade atendida
      return this.pedido_material.every((material_pedido) => {
        const quantidadeAtendida =
          parseFloat(material_pedido.quantidade_atendida) || 0;
        const somaDebitar =
          this.somaQuantidadesDebitar[material_pedido.id] || 0;

        // A soma deve ser igual à quantidade atendida (não pode ser menor nem maior)
        return somaDebitar === quantidadeAtendida;
      });
    },
  },
  watch: {
    // Observa mudanças na estrutura de estoques para executar validações
    pedido_material: {
      deep: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.validarQuantidades();
        });
      },
    },
  },
  methods: {
    // Valida as quantidades a debitar
    validarQuantidades() {
      this.pedido_material.forEach((material_pedido) => {
        if (material_pedido.estoques) {
          material_pedido.estoques.forEach((estoque) => {
            // Validar se quantidade a debitar não excede quantidade disponível no lote
            this.validarQuantidadeLote(estoque);
          });

          // Validar se soma das quantidades a debitar não excede quantidade atendida
          this.validarSomaQuantidades(material_pedido);
        }
      });
    },

    // Valida se a quantidade a debitar não excede a quantidade disponível no lote
    validarQuantidadeLote(estoque) {
      if (
        estoque.quantidade_debitar &&
        !isNaN(parseFloat(estoque.quantidade_debitar))
      ) {
        const quantidadeDebitar = parseFloat(estoque.quantidade_debitar);
        const quantidadeDisponivel = parseFloat(estoque.quantidade);

        if (quantidadeDebitar > quantidadeDisponivel) {
          this.$set(estoque, "erro_quantidade", true);
          this.$set(
            estoque,
            "mensagem_erro",
            `Quantidade a debitar (${quantidadeDebitar}) excede a disponível (${quantidadeDisponivel})`
          );

          // Ajustar automaticamente para a quantidade máxima disponível
          this.$set(estoque, "quantidade_debitar", quantidadeDisponivel);

          this.$message(
            null,
            `Quantidade ajustada automaticamente para ${quantidadeDisponivel} (máximo disponível no lote ${estoque.lote})`,
            "warning"
          );
        } else {
          this.$set(estoque, "erro_quantidade", false);
          this.$set(estoque, "mensagem_erro", "");
        }
      }
    },

    // Valida se a soma das quantidades a debitar está correta em relação à quantidade atendida
    validarSomaQuantidades(material_pedido) {
      const somaDebitar = this.somaQuantidadesDebitar[material_pedido.id] || 0;
      const quantidadeAtendida =
        parseFloat(material_pedido.quantidade_atendida) || 0;

      if (somaDebitar > quantidadeAtendida) {
        this.$set(material_pedido, "erro_soma", true);
        this.$set(material_pedido, "tipo_erro_soma", "excesso");
        this.$set(
          material_pedido,
          "mensagem_erro_soma",
          `Soma das quantidades a debitar (${somaDebitar}) excede a quantidade atendida (${quantidadeAtendida})`
        );
      } else if (somaDebitar < quantidadeAtendida) {
        this.$set(material_pedido, "erro_soma", true);
        this.$set(material_pedido, "tipo_erro_soma", "insuficiente");
        this.$set(
          material_pedido,
          "mensagem_erro_soma",
          `Quantidade insuficiente para debitar (${somaDebitar}) - faltam ${quantidadeAtendida - somaDebitar
          } para atingir ${quantidadeAtendida}`
        );
      } else {
        this.$set(material_pedido, "erro_soma", false);
        this.$set(material_pedido, "tipo_erro_soma", "");
        this.$set(material_pedido, "mensagem_erro_soma", "");
      }
    },

    // Método para gerenciar a seleção do checkbox e resetar quantidade quando necessário
    onCheckboxChange(estoque) {
      if (!estoque.selecionado) {
        // Se desmarcou o checkbox, limpa a quantidade
        this.$set(estoque, "quantidade_debitar", null);
        this.$set(estoque, "erro_quantidade", false);
        this.$set(estoque, "mensagem_erro", "");
      }
    },

    add() {
      if (!this.adicao.obj_material || !this.adicao.quantidade) {
        this.$message(
          null,
          "Selecione o material e informe a quantidade.",
          "warning"
        );
        return;
      }

      const existente = this.pedido_material.find(
        (item) =>
          item.material &&
          this.adicao.obj_material &&
          item.material.id === this.adicao.obj_material.id
      );


      if (existente) {
        this.$message(null, "Este material já foi adicionado.", "warning");
        return;
      }

      this.pedido_material.push({
        material: this.adicao.obj_material,
        quantidade_solicitada: this.adicao.quantidade,
        quantidade_atendida: 0,
        atendido: null,
        id: null,
      });

      // Resetar campos
      this.adicao.obj_material = null;
      this.adicao.quantidade = null;
    },
    reject: function () {
      const self = this;
      let api =
        self.$store.state.api + `rejeita-pedido/${self.$route.params.id}`;

      axios
        .post(api, self.pedido_material)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    approve: function () {
      const self = this;
      let api = self.$store.state.api + "aprova-pedido";

      if (self.pedido.observacoes) {
        self.saveObservacao(self.pedido);
      }

      axios
        .post(api, self.pedido_material)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    reabrir: function () {
      const self = this;
      let api = self.$store.state.api + "reabrir-pedido";

      axios
        .post(api, self.pedido)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    finalizar: function () {
      const self = this;

      if (!self.ignorar_distribuicao) {
        // Executar validações antes de finalizar
        self.validarQuantidades();

        // Verificar se há erros de validação
        let temErros = false;

        self.pedido_material.forEach((material_pedido) => {
          if (material_pedido.erro_soma) {
            temErros = true;
          }

          if (material_pedido.estoques) {
            material_pedido.estoques.forEach((estoque) => {
              if (estoque.erro_quantidade) {
                temErros = true;
              }
            });
          }
        });

        if (temErros) {
          self.$message(
            null,
            "Corrija os erros de validação antes de finalizar o pedido.",
            "error"
          );
          return;
        }

        // Verificar se é possível finalizar (todas as quantidades devem estar completas)
        if (!self.podeFinalizarPedido) {
          self.$message(
            null,
            "A quantidade total para debitar deve ser igual à quantidade atendida para todos os materiais antes de finalizar o pedido.",
            "error"
          );
          return;
        }
      }

      // Preparar dados com estoques selecionados e quantidades a debitar
      const dadosParaEnvio = self.pedido_material.map((material_pedido) => {
        // Coletar IDs dos estoques selecionados
        const estoquesSelecionados = [];

        if (material_pedido.estoques) {
          material_pedido.estoques.forEach((estoque) => {
            if (estoque.selecionado) {
              estoquesSelecionados.push({
                id: estoque.id,
                quantidade_debitar: estoque.quantidade_debitar,
              });
            }
          });
        }

        return {
          id: material_pedido.id,
          material_id: material_pedido.material_id,
          quantidade_solicitada: material_pedido.quantidade_solicitada,
          quantidade_atendida: material_pedido.quantidade_atendida,
          atendido: material_pedido.atendido,
          estoques_selecionados: estoquesSelecionados,
        };
      });

      let api =
        self.$store.state.api + `finaliza-pedido/${self.$route.params.id}`;

      axios
        .post(api, {
          materiais: dadosParaEnvio,
          ignorar_distribuicao: self.ignorar_distribuicao,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    baixa: function () {
      const self = this;
      let api =
        self.$store.state.api + `solicita-baixa/${self.$route.params.id}`;

      axios
        .post(api, self.pedido_material)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPedidos: function (id) {
      const self = this;
      const api = self.$store.state.api + "pedidos/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.pedido = response.data.data[0];
          self.pedido.observacoes = self.pedido.observacoes || '';
          self.ignorar_distribuicao = self.pedido.ignorar_distribuicao || false;

          // Usar $nextTick para garantir reatividade
          self.$nextTick(() => {
            // Verificar se o pedido foi recebido parcialmente após o pedido estar carregado
            const temQuantidadeAtendida = self.pedido.recebido === 3;
            self.$set(self, "temQuantidadeAtendida", temQuantidadeAtendida);
          });

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getMateriais: function () {
      const self = this;
      const api = self.$store.state.api + `materiais?paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.materiais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getMaterialPedidos: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        `material_pedidos?paginated=false&pedido_id=${id}&with[]=material&with[]=estoques.fabricante`;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.pedido_material = response.data.data || [];

          // Usar $nextTick para garantir que os dados estejam renderizados
          self.$nextTick(() => {
            // Verificar se o pedido foi recebido parcialmente (recebido = 3)
            const temQuantidadeAtendida = self.pedido.recebido === 3;

            // Usar $set para garantir reatividade
            self.$set(self, "temQuantidadeAtendida", temQuantidadeAtendida);

            // Inicializar propriedades para estoques e validação
            self.pedido_material.forEach((material_pedido) => {
              // Inicializar propriedades de validação do material
              self.$set(material_pedido, "erro_soma", false);
              self.$set(material_pedido, "mensagem_erro_soma", "");

              if (material_pedido.estoques) {
                material_pedido.estoques.forEach((estoque) => {
                  self.$set(estoque, "selecionado", false);
                  self.$set(estoque, "quantidade_debitar", null);
                  self.$set(estoque, "erro_quantidade", false);
                  self.$set(estoque, "mensagem_erro", "");
                });
              }
            });
          });

          self.$loading(false);
        })
        .catch((error) => {
          self.pedido_material = [];
          self.$loading(false);
          console.error("Erro:", error);
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getObservacoes: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "observacoes?paginated=false&with[]=user&pedido_id=" +
        id;

      axios
        .get(api)
        .then((response) => {
          self.observacoes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    authorize: function () {
      const self = this;
      let api = self.$store.state.api + "autoriza";

      axios
        .post(api, { pedido: self.pedido, materiais: self.pedido_material })
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/pedidos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveObservacao: function (pedido) {
      const self = this;
      let api = self.$store.state.api + "observacoes";

      axios
        .post(api, {
          user_id: self.$store.state.user.id,
          pedido_id: pedido.id,
          texto: pedido.observacoes,
        })
        .then(() => { })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getUnidades();
    self.getMateriais();

    if (id) {
      self.getPedidos(id);
      self.getObservacoes(id);
      self.getMaterialPedidos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.badge-orange {
  background: #d34300;
  color: white;
}

.btn-outline-purple:hover,
.badge-purple {
  background: #880088;
  color: white;
}

.btn-outline-purple {
  border: 2px solid #880088;
  color: #000000;
}

/* Estilos para validação */
.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.text-danger {
  color: #dc3545 !important;
}

.text-warning {
  color: #ffc107 !important;
}

.text-success {
  color: #28a745 !important;
}

/* Estilo para campos desabilitados */
.form-control:disabled {
  background-color: #f8f9fa;
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
